import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { Observable, of } from 'rxjs'
import { filter, map, switchMap, take } from 'rxjs/operators'
import { AppState } from '../store/state/app.state'
import { getEnabledModules, getSettingsLoaded } from '../store/selector/company-settings.selector'
import { getUserTypeFromState } from '../store/selector/initialize.selector'
import { GlobalConstants } from '../constants/global-constants'
import { getFirstAvailableRoute } from '../utils/module-routing.util'

export const ModuleRouteGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store<AppState>)
  const router = inject(Router)

  const requiredModule: string = route.data['requiredModule']

  return store.select(getUserTypeFromState).pipe(
    filter(userType => !!userType),
    take(1),
    switchMap(userType => {
      if (userType !== GlobalConstants.USER_TYPE.EMPLOYEE_ADMIN) {
        return of(true)
      }
      return store.select(getSettingsLoaded).pipe(
        filter(loaded => loaded),
        take(1),
        switchMap(() => store.select(getEnabledModules).pipe(
          take(1),
          map(modules => {
            if (modules.includes(requiredModule)) return true
            return router.createUrlTree([getFirstAvailableRoute(modules)])
          })
        ))
      )
    })
  ) as Observable<boolean | import('@angular/router').UrlTree>
}
